import { render } from "./PhoneCountryInput.vue?vue&type=template&id=82d50498&scoped=true"
import script from "./PhoneCountryInput.vue?vue&type=script&lang=js"
export * from "./PhoneCountryInput.vue?vue&type=script&lang=js"

import "./PhoneCountryInput.vue?vue&type=style&index=0&id=82d50498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d50498"]])

export default __exports__